import locales from './locales/';

function getLocaleFor(localeId) {
  return locales[localeId];
}

function loadResourcesWithFallbacks(localeId) {
  const localeObjects = [];

  let currentLocaleId = localeId;

  while (currentLocaleId) {
    const thisLocale = getLocaleFor(currentLocaleId);

    if (thisLocale) {
      localeObjects.push(thisLocale);
      currentLocaleId = thisLocale.extendsLocale;
    } else {
      throw new Error(`No resources found for locale ${currentLocaleId}`);
    }
  }

  localeObjects.reverse();
  const resources = localeObjects.map(e => e.resources);
  const result = Object.assign({}, ...resources);
  return result;
}

function getResource(res, key) {
  const resource = res[key];

  if (resource !== undefined) {
    return resource;
  } else {
    throw new Error(`Could not find resource for key '${key}'`);
  }
}

class Localiser {
  loadResourcesFor(locale) {
    const result = loadResourcesWithFallbacks(locale);
    global.resx = getResource.bind(this, result);
  }
}

export default new Localiser();
